import notificationService from './notification.service';

export {notificationService};
